import HWY_Accordion from "./accordion";
import HWY_CountDown from "./countdown";
import HWY_Slider from "./slider";

export default function Modules() {
	this.init = () => {
		new HWY_Accordion().init();
		new HWY_CountDown().init();
		new HWY_Slider().init();
	};
}